/// <reference types="./arrow_left_line.d.mts" />
import * as $svg from "../../ds/internals/svg.mjs";

export function arrow_left_line() {
  return $svg.square(
    24,
    "<path d=\"M10.828 12.1147L15.778 17.0647L14.364 18.4787L8 12.1147L14.364 5.75073L15.778 7.16473L10.828 12.1147Z\" fill=\"currentColor\"/>",
  );
}
